import { useQuery } from "react-query";
import queryKeys from "../../../constants/queryKeys";
import auditService from "../../services/auditService";

const useSiteAudits = ({ externalIds }) =>
  useQuery(
      [queryKeys.siteAudits, externalIds?.join(",")],
    () => auditService.fetchAuditsForSite(externalIds),
    {
      enabled: !!externalIds?.length,
    }
  );
  

export default useSiteAudits;
